export default __webpack_public_path__ + "37aaab76baf435b5d611a24233f74b2d.svg";